import React, { Component } from "react";
import messages from "./Login.messages";
import { Link } from "react-router-dom";
import LoginForm from "../../../components/forms/login-form/LoginForm";
import { getAuthToken, isMobile } from "../../../helpers/Utils";

type Props = {
  onRequestLogin: () => void,
  showIncorrectPasswordError: () => void,
  showInvalidEmailError: () => void,
  redirectToRegister: () => void,
};

export default class Login extends Component {
  props: Props;

  handleRegisterRedirect = (event) => {
    event.preventDefault();
    this.props.redirectToRegister();
  };

  render() {
    // Used to prevent showing the login page every time the app is loaded.
    // We're saving a "token" to the browser storage that will be quicker and
    // easier to access to tell if the user should be logged in or not.  While
    // waiting for firebase to get authenticated we're showing a loading
    // indicator instead of flashing the login page.
    if (getAuthToken() && getAuthToken().uid)
      return (
        <div className="loading-container">
          <div className="loading-circle"></div>
        </div>
      );

    return (
      <div>
        <h1 className="loope-title">{messages.login}</h1>
        {this.props.showIncorrectPasswordError
          ? this.renderIncorrectPasswordError()
          : null}
        {this.props.showInvalidEmailError
          ? this.renderInvalidEmailError()
          : null}
        <div className="row">
          <div className="col-xs-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
            <LoginForm onRequestLogin={this.props.onRequestLogin}></LoginForm>
            <hr />
            {/* TODO Might need to disable the register button for Apple's apporoval. */}
            {/* {!isMobile() && ( */}
            <button
              bsStyle="default"
              onClick={this.handleRegisterRedirect}
              className="m-b-15 jr-btn btn btn-default register-btn"
            >
              {messages.register}
            </button>
            {/* )} */}
            <Link to="/forgot-password" className="login-link">
              {messages.forgot}
            </Link>
          </div>
        </div>
      </div>
    );
  }

  renderIncorrectPasswordError() {
    return <div style={{ color: "red" }}>{messages.invalidError}</div>;
  }

  renderInvalidEmailError() {
    return <div style={{ color: "red" }}>{messages.invalidError}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/views/guest/login/Login.js